<template>
    <div class="content page page-work-show" :class="{
        'hide-banner': hideBanner,
    }">
        <div class="banner" :style="{
            backgroundImage: 'url('+ShowBanner+')',
        }"></div>
        <div class="content-body">
            <div class="left-box">
                <div class="card">
                    <div class="title">{{ work.name }}</div>

                    <div class="content-box" ref="contentRef">
                        <WorkVideo v-if="work.video?.id" :file_id="work.video.id"></WorkVideo>
                        <div v-else class="images-container">
                            <img v-for="image in work.images" class="img" :src="image.url" alt="">
                        </div>
                        <div v-if="work.content" class="article-content" v-html="work.content"></div>
                    </div>
                </div>

                <div v-if="!hideComment" class="comment-container">
                    <div class="title">评论（{{ work.comments_count }}）</div>
                    <div class="comment-list">
                        <div class="comment-create-container">
                            <div class="comment-info">
                                <Textarea class="comment-input" v-model:value="comment.content"
                                          placeholder="说点什么吧……" showCount
                                          @keydown.enter="submitComment"
                                          :autosize="{
                                              minRows: 4,
                                          }"
                                          :maxlength="255"></Textarea>
                                <div class="tips">
                                    Enter 发表
                                </div>
                            </div>
                        </div>
                        <div class="comment-box">
                            <LoadMoreList :loadPage="loadComment" ref="commentListLoadMore">
                                <template #no-more>没有更多评论了</template>
                                <template #item="{item, index}">
                                    <CommentItem :item="item" @delete="onDeleteComment(item)"></CommentItem>
                                </template>
                            </LoadMoreList>
                        </div>
                    </div>
                </div>

            </div>
            <div class="right-box">
                <div class="action-box">
                    <Button v-if="props.isPreview && work.attachment" class="btn">免费下载</Button>
                    <WorkDownloadLink v-if="!props.isPreview && work.attachment" :work="work">
                        <template #default="{btnTitle}">
                            <Button class="btn">{{ btnTitle }}</Button>
                        </template>
                    </WorkDownloadLink>

                    <Button v-if="props.isPreview" class="btn">收藏</Button>
                    <Collect v-else :is-collected="work.collect_status"
                             :collect-url="route('api.work.collect',{work: work.id})">
                        <template #unCollected>
                            <Button class="btn">收藏</Button>
                        </template>
                        <template #collected>
                            <Button class="btn grey">已收藏</Button>
                        </template>
                    </Collect>
                </div>
                <div class="stat">
                    <div class="stat-item"><i class="pt-icons-visit"></i> {{ work.view_count }}</div>
                    <div class="stat-item"><i class="pt-icons-comment"></i>{{ work.comments_count }}</div>
                    <div v-if="props.isPreview" class="stat-item"><i
                        class="pt-icons-pickup active"></i>{{ work.likes_count }}
                    </div>
                    <Like class="stat-item"
                          v-else
                          :is-like="work.like_status"
                          :class="{active: work.like_status}"
                          :like-url="route('api.work.like',{work: work.id})">
                        <template #liked>
                            <i class="pt-icons-pickup active"></i>{{ work.likes_count + 1 }}
                        </template>
                        <template #unLiked>
                            <i class="pt-icons-pickup"></i>{{ work.likes_count }}
                        </template>
                    </Like>
                </div>
                <div class="info-box">
                    <div class="title">详细信息:</div>
                    <div class="text">作品分类：{{ work.cate_name }}</div>
                    <div class="text">作品范围：{{ work.copy_right_text }}</div>
                    <div class="text">作品来源：{{ work.source_type_text }}</div>

                    <template v-if="file">
                        <div class="text">文件大小：{{ file.size }}</div>
                        <div class="text">文件格式：{{ file.ext }}</div>
                    </template>
                    <div class="text">版权所有：批图网</div>
                </div>

                <div class="bottom-box">
                    <Link @click="reportModalVisible=true"
                          class="report">
                        <i class="pt-icons-report"></i>举报
                    </Link>
                    <div class="tag-box">
                        <Link v-if="work.tags?.length > 0" class="tag" v-for="(tag, index) in work.tags"
                              :href="props.isPreview?'javascript:void(0);':route('work.index', {search: tag.name})"
                              :key="index">
                            {{ tag.name }}
                        </Link>
                        <Link v-if="work.other_tags?.length > 0" class="tag" v-for="(tag, index) in work.other_tags"
                              :href="props.isPreview?'javascript:void(0);':route('work.index', {search: tag})"
                              :key="index">
                            {{ tag }}
                        </Link>
                    </div>
                    <div class="author-box">
                        <div class="title">发布者:</div>
                        <Link :href="route('user.show',{uid: work.user.uid})" class="author">
                            <Avatar class="avatar-container" :user="work.user">
                                <img :src="work.user.avatar.url" class="avatar"/>
                            </Avatar>
                            <div class="info">
                                <div class="name">{{ work.user.nickname }}</div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Modal v-model:visible="reportModalVisible" :width="660">
        <FeedbackModalContent type="report" title="作品举报">
        </FeedbackModalContent>
    </Modal>
</template>

<script setup lang="ts">
import {computed, getCurrentInstance, inject, onMounted, ref, watch} from "vue";
import LoadMoreList from '@/Components/Common/LoadMoreList.vue'
import {useForm, usePage} from "@inertiajs/vue3";
import {Button, Textarea} from "ant-design-vue";
import Link from '@/Components/Link.vue'
import {calcSizeText, formatFile} from "@/Components/Common/Form/Uploader/utils";
import Like from "@/Components/Like.vue";
import http from "@/utils/http";
import WorkVideo from "@/Components/WorkVideo.vue";
import WorkDownloadLink from "@/Components/WorkDownloadLink.vue";
import Modal from "@/Components/Common/Modal.vue";
import FeedbackModalContent from "@/Components/FeedbackModalContent.vue";
import Avatar from "@/Components/Avatar.vue";
import {route} from "@/utils/common";
import ShowBanner from "@/../images/show-banner.jpg";
import CommentItem from "@/Components/Work/CommentItem.vue";
import Collect from "@/Components/Collect.vue";
import {message} from "@/utils/modal";
import Viewer from "viewerjs";


const props = withDefaults(defineProps<{
    work: any,

    hideComment?: boolean,
    hideBanner?: boolean | null,
    isPreview?: boolean,
}>(), {
    hideComment: false,
    hideBanner: null,
    isPreview: false,
})

const hideBanner = ref(props.hideBanner)
const reportModalVisible = ref(false)
const work = ref(props.work)
const commentListLoadMore = ref()
const contentRef = ref()

const ins = getCurrentInstance()

if (hideBanner.value === null) {
    if (inject('inModal', false)) {
        hideBanner.value = true
    } else {
        hideBanner.value = false
    }
}

const loadComment = async (page) => {
    return await http.get(route('api.work.comment.index', {work: props.work.id}) + '?page=' + page)
}

const file = computed(() => {
    if (!work.value.attachment) {
        return null
    }
    let size = 0
    let ext = []
    work.value.attachment.forEach((item) => {
        size += (item.size - 0)
        ext.push(formatFile(item).ext)
    })
    ext = Array.from(new Set(ext))
    return {
        size: calcSizeText(size),
        ext: ext.join(', ')
    }
})

const user = usePage().props.auth?.user

const comment = useForm({
    content: ''
})

watch(() => props.work, () => {
    work.value = props.work
})


const submitComment = async () => {
    await http.post(route('api.work.comment.create', {work: props.work.id}), comment.data())
    if (commentListLoadMore.value) {
        commentListLoadMore.value.reloadPage()
    }
    comment.content = ''
}

const onDeleteComment = (item: any) => {
    message({
        content: '确定删除此评论',
        btns: [
            {
                text: '删除',
                async onClick(v) {
                    await http.delete(route('api.work.comment.destroy', {comment: item.id}))
                    commentListLoadMore.value.reloadPage()

                    v.value = false
                }
            }
        ]
    })
}

onMounted(() => {
    if (!contentRef.value) {
        return
    }
    let zooming = false
    const r = 0.25
    let hiding = false
    const viewer = new Viewer(contentRef.value, {
        minZoomRatio: r,
        maxZoomRatio: 5,
        toolbar: {
            zoomIn: true,
            zoomOut: true,
            prev: true,
            play: true,
            next: true,
            rotateLeft: true,
            rotateRight: true,
            reset: true,
        },
        hide(event: CustomEvent) {
            if (hiding) {
                return
            }
            hiding = true
            event.preventDefault()
            viewer.hide(true)
            hiding = false
        },
        zoom(event: Viewer.ZoomEvent) {
            if (zooming) {
                return
            }
            event.preventDefault()
            if (event.detail.ratio == event.detail.oldRatio) {
                return;
            }
            zooming = true
            let ratio = event.detail.ratio
            ratio = parseInt((ratio / r) + '')
            ratio += event.detail.ratio > event.detail.oldRatio ? 1 : -1
            viewer.zoomTo(ratio * r, true)
            zooming = false
        },
    })
    document.querySelectorAll('.page-work-show .content-body .content-box img').forEach((img: HTMLImageElement) => {
        img.title = '点击放大查看'
    })
})

</script>

<style lang="less">
.viewer-player {
    cursor: auto !important;
}
</style>

<style scoped lang="less">
.content {
    .banner {
        height: 250px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    }

    .content-body {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        align-items: flex-start;
        padding-top: 70px;

        .left-box {
            width: 680px;
            flex-shrink: 0;

            .card {
                margin-left: 40px;
                padding: 20px;
                box-shadow: 0 2px 6px 0 rgba(4, 0, 0, 0.12);

                .title {
                    font-size: 18px;
                }

                .content-box {
                    margin-top: 20px;
                    color: #989898;

                    :deep(.article-content) {
                        p {
                            line-height: 1.2;
                            font-size: 14px;
                        }
                    }

                    .images-container {
                        display: flex;
                        flex-wrap: wrap;
                        margin-left: -10px;
                    }

                    :deep(img) {
                        cursor: pointer;
                        max-width: 100%;
                        margin-left: 10px;

                        & + .img {
                            margin-top: 10px;
                        }
                    }
                }
            }

            .comment-container {
                margin-top: 60px;

                .title {
                    color: #222222;
                    font-size: 20px;
                }

                .comment-list {
                    padding-left: 10px;
                    margin-top: 20px;

                    .comment-create-container {
                        .comment-info {
                            position: relative;

                            .comment-input {
                                :deep(.ant-input) {
                                    border-radius: 4px;
                                }

                                &::after {
                                    right: auto;
                                    left: 20px;
                                    float: left;
                                }
                            }

                            .tips {
                                position: absolute;
                                right: 10px;
                                bottom: 5px;
                                font-size: 12px;
                                color: #CCCCCC;
                            }
                        }
                    }

                    .comment-box {
                        margin-top: 50px;

                    }
                }
            }

        }

        .right-box {
            padding-top: 10px;
            margin-left: 80px;
            position: sticky;
            top: 80px;

            .action-box {
                display: flex;
                align-items: center;

                .btn {
                    border: 1px solid #2E2E2E;
                    border-radius: 6px;
                    margin-right: 10px;
                    padding: 0 20px;
                    font-size: 14px;
                    height: 36px;

                    &.grey {
                        border: 1px solid transparent;
                    }

                    &:hover {
                        opacity: .8;
                    }
                }
            }

            .stat {
                display: flex;
                align-items: center;
                margin-top: 30px;

                .stat-item {
                    color: #666666;
                    display: flex;
                    align-items: center;

                    i {
                        color: #CCCCCC;
                        font-size: 14px;
                        margin-right: 10px;

                        &.active {
                            color: #FE2444;
                        }
                    }

                    & + .stat-item {
                        margin-left: 30px;
                    }
                }
            }

            .info-box {
                margin-top: 30px;
                color: #666666;
                font-size: 14px;

                .title {
                    color: #2E2E2E;
                    font-size: 16px;
                }

                .text {
                    margin-top: 20px;
                }
            }

            .bottom-box {
                margin-top: 20px;
                border-top: 1px solid #EEEEEE;

                .report {
                    display: flex;
                    align-items: center;
                    margin-top: 20px;

                    i {
                        margin-right: 6px;
                    }
                }

                .tag-box {
                    margin-top: 20px;
                    overflow: hidden;
                    margin-left: -20px;

                    .tag {
                        color: #2E2E2E;
                        float: left;
                        margin-left: 20px;
                        margin-top: 10px;
                        background: #F6F6F6;
                        padding: 10px 20px;
                        border-radius: 18px;
                        font-size: 14px;
                    }
                }

                .author-box {
                    margin-top: 40px;

                    .title {
                        font-size: 16px;
                        color: #2E2E2E;
                    }

                    .author {
                        margin-top: 20px;
                        display: flex;
                        align-items: center;
                        transition: all .3s;

                        &:hover {
                            opacity: .8;
                        }

                        .avatar-container {
                            width: 60px;
                            height: 60px;

                            .avatar {
                                border-radius: 50%;
                            }
                        }

                        .info {
                            margin-left: 20px;

                            .name {
                                color: #2E2E2E;
                                font-size: 18px;
                            }

                            .id {
                                margin-top: 10px;
                                color: #2E2E2E;
                            }
                        }
                    }
                }
            }
        }
    }

    &.hide-banner {
        padding-bottom: 60px;

        .banner {
            display: none;
        }

        .content-body {
            padding-top: 60px;
        }
    }
}
</style>
